"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CryptoText = exports.CurrencyButton = exports.StyledInput = exports.SelectWrapper = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.SelectWrapper = styled_components_1.default.div `
  display: flex;

  background: #f1f7fd;
  border: 1px solid #d4d9e8;
  border-radius: 12px;
  align-items: center;
  justify-content: space-between;

  width: 100%;
  height: 50px;

  padding: 0;
`;
exports.StyledInput = styled_components_1.default.input `
  border: none;
  outline: none;
  height: 100%;
  background: transparent;
  padding: 16px 0 16px 16px;
  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0em;
  width: 100%;

  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
  }
`;
exports.CurrencyButton = styled_components_1.default.button `
  border: none;
  background: none;

  border-left: 1px solid #d4d9e8;
  padding: 16px;
  display: flex;
  min-width: 122px;

  justify-content: space-between;
  align-items: center;

  grid-gap: 8px;

  font-size: 16px;
  font-weight: 600;
  line-height: 19px;
  letter-spacing: 0em;
  cursor: pointer;
`;
exports.CryptoText = styled_components_1.default.span `
  margin-right: 8px;
`;
//# sourceMappingURL=styled.js.map